import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=57a48126&scoped=true&"
import script from "./ToDo.vue?vue&type=script&lang=js&"
export * from "./ToDo.vue?vue&type=script&lang=js&"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=57a48126&lang=scss&scoped=true&"
import style1 from "./ToDo.vue?vue&type=style&index=1&id=57a48126&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a48126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a48126')) {
      api.createRecord('57a48126', component.options)
    } else {
      api.reload('57a48126', component.options)
    }
    module.hot.accept("./ToDo.vue?vue&type=template&id=57a48126&scoped=true&", function () {
      api.rerender('57a48126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Edit/ToDo.vue"
export default component.exports